<template>
    <div class="container" style="width: 100%;">
        <div class="row" style="width:100%">
            <div style="margin: 0 auto">
                <q-btn color="primary" stack push ripple="false" to="item" style="margin: 10px; width: 130px; height: 130px;">
                    <div><q-icon size="50px" name="document_scanner" /></div>
                    <div style="margin-top:10px;font-size:18px; font-weight:bold;">Scan Item</div>
                </q-btn>
                <q-btn color="primary" stack push ripple="false" to="stocktake" style="margin: 10px; width: 130px; height: 130px;">
                    <div><q-icon size="50px" name="checklist_rtl" /></div>
                    <div style="margin-top:10px;font-size:18px; font-weight:bold;">Stock Take</div>
                </q-btn>
            </div>
        </div>
        <div class="row" style="width:100%">
            <div style="margin: 0 auto">
                <q-btn color="primary" stack push ripple="false" to="order" style="margin: 10px; width: 130px; height: 130px;">
                    <div><q-icon size="50px" name="local_shipping" /></div>
                    <div style="margin-top:10px;font-size:18px; font-weight:bold;">Fullfill Order</div>
                </q-btn>
                <q-btn color="primary" stack push ripple="false" to="link" style="margin: 10px; width: 130px; height: 130px;">
                    <div><q-icon size="50px" name="route" /></div>
                    <div style="margin-top:10px;font-size:18px; font-weight:bold;">Assign Barcode</div>
                </q-btn>
            </div>
        </div>  
    </div>
</template>

<script>
export default {
  name: 'scan_home',
  data(){
    return {
      name:"Hello",
      password: ""
    }
  },
  methods:{
    printPage(){
        router.push('/users/eduardo')
        window.print();
    }
  }
}
</script>
